<template>
<div>
<div class="bgd-pink2">
    <h1>Let’s be fast friends: Your 1st month is free </h1>
    <h2>Your new employee wellbeing strategy starts here.</h2>
    <!-- <div class="img"></div> -->
    <ul>
        <li>Zero lock in clauses – cancel anytime</li>
        <li>Pay month by month from as little as $2.39 per month per employee</li>
        <li>Only get charged for employees when they download the Beny App</li>
        <li>Your 1st month with Beny is on the house</li>
    </ul>
</div>
<div class="bgd-black">
    <div class="card">
        <h1>Company</h1>
        <h2>For team use</h2>
        <h3><span>$</span>4.99</h3>
        <h2 style="margin-bottom:41px">Per user per month</h2>
        <h4>Up to 19 active users</h4>
        <h4 style="margin-bottom:44px">Beny Day</h4>
        <button @click="jump('/registered')">Get started</button>
    </div>
    <div class="table">
        <div class="table-head clear">
            <div class="lft">Number of employees who have<br />downloaded Beny</div>
            <div class="rgt">Fee per month per<br />employee </div>
        </div>
        <div class="table-body">
            <div class="clear">
                <div class="lft">0-100<br />(fees capped at 80 employees)</div>
                <div class="rgt">$4.99</div>
            </div>
            <div class="clear">
                <div class="lft">101-500<br />(fees capped at 375 employees)</div>
                <div class="rgt">$3.99</div>
            </div>
            <div class="clear">
                <div class="lft">501-1000<br />(fees capped at 800 employees)</div>
                <div class="rgt">$2.99</div>
            </div>
            <div class="clear">
                <div class="lft">1000-1500<br />(fees capped at 1,250 employees)</div>
                <div class="rgt">$2.39</div>
            </div>
            <div class="clear">
                <div class="lft pad-top-23">1501+</div>
                <div class="rgt"><span class="link" @click="contactShow(true)">Contact Beny</span></div>
            </div>
        </div>
    </div>
    <div class="triple clear">
        <div class="box" style="width:380px">
            <h1>All friends of Beny get <br/>to enjoy these <br/>features </h1>
        </div>
        <div class="box" style="width:380px">
            <p class="tit">Unlock 1000’s of exclusive benefits</p>
            <p class="txt" style="margin-bottom: 78px;">Access wellness and wellbeing benefits in the palm of your hands. All of our big-name benefits are housed in a convenient and accessible App, available 24/7 for all users.</p>
            <p class="tit">Inspiration for all</p>
            <p class="txt">Get access to regular topical articles at your fingertips. The Beny App is home to interesting, insightful, and inspiring content centred around total wellbeing.</p>
            <p class="tit">Seamless integration into daily life</p>
            <p class="txt">Simple to enrol and equally simple to use, the Beny platform is expertly designed to be easy for everyone (we mean it – everyone). Our intuitive system enables instant enrolment and oversight 
for company administrators. </p>
        </div>
        <div class="box" style="width:390px">
            <p class="tit">A solution to holistic employee wellbeing</p>
            <p class="txt">Beny considers the mental, financial, physical, and social wellbeing of your organisation. We’re an employee wellbeing solution that understands and supports the whole person, holistically.</p>
            <p class="tit">The power of a Beny Day</p>
            <p class="txt">Improve employee wellbeing by offering a day of leave, dedicated to reviewing their financial matters annually: from home finance and insurance to utilities and everything in between.</p>
            <p class="tit">Insightful Data</p>
            <p class="txt">Understand what your team (truly) want and need, with live data and reporting. Already integrated into the Beny platform, you’ll have the insight and the foresight to plan ahead and optimise your employee value proposition.</p>
        </div>
    </div>
</div>
<!-- <div class="svgLine_box">
    <svg
    preserveAspectRatio="none"
    viewBox="-450 -450 900 900"
    xmlns="http://www.w3.org/2000/svg"
    style="fill:#302E2C; width: 100%; height: 90px;"
    >
        <path d='M-466,-11 C0,-769 381,-148 453,-5'/>
    </svg>
</div> -->
<!-- <div class="dark-wrap">
<div class="dark-black">
    <h1>Frequently asked questions</h1>
    <div class="clear">
        <div class="box">
            <h2>How does Beny pricing work?</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Aliquam sit amet vehicula orci. Duis sed laoreet erat.
            Integer rutrum.</p>
        </div>
        <div class="box">
            <h2>Is there a free trial period?</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Aliquam sit amet vehicula orci. Duis sed laoreet erat.
            Integer rutrum.</p>
        </div>
        <div class="box">
            <h2>Who can benefit from it?</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Aliquam sit amet vehicula orci. Duis sed laoreet erat.
            Integer rutrum.</p>
        </div>
        <div class="box">
            <h2>How can I use Beny?</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Aliquam sit amet vehicula orci. Duis sed laoreet erat.
            Integer rutrum.</p>
        </div>
        <div class="box">
            <h2>Whom should I contact in case of any problems?</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Aliquam sit amet vehicula orci. Duis sed laoreet erat.
            Integer rutrum.</p>
        </div>
        <div class="box">
            <h2>Can I cancel subscription at any time?</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Aliquam sit amet vehicula orci. Duis sed laoreet erat.
            Integer rutrum.</p>
        </div>
    </div>
    <h3>Do you have more questions? Feel free to <a href="#" target="_blank">contact us</a></h3>
</div>
</div> -->
<div class="pink-wrap2">
    <div class="pink">
        <div class="content clear">
            <div class="lft">
                <h1>Become a Beny Organisation today.</h1>
                <h2>
                    Ready to become fast friends with Beny? Sign up today in less time than it takes to make a <br/>
                    coffee and give your employees not only access to 1000’s of big-name benefits, but the <br/>
                    valuable wellness and wellbeing support that gets them from nine to thrive.
                </h2>
                <button @click="jump('/registered')">Get started</button>
            </div>
            <div class="rgt"></div>
        </div>
    </div>
</div>

<contact :show="showContact" @close="contactShow" />
</div>
</template>

<script>
import contact from '@/components/common/contact.vue'

export default {
    name: 'pricing',
    data () {
        return {
            showContact: false
        }
    },
    methods: {
        jump (path) {
            this.$router.push(path)
        },
        contactShow(boo) {
            this.showContact = boo
        }
    },
    components: {
        contact
    }
}
</script>

<style lang="scss" scope>
.table{
    margin-bottom: 100px;
.table-head{
    width: 504px;
    margin: 0 auto;
    .lft, .rgt{
        font-size: 17px;
        font-family: Assistant-Bold, Assistant;
        font-weight: bold;
        color: #3A3835;
        line-height: 20px;
        box-sizing: border-box;
        padding:13px 0;
        background-color: #F8A4AE;
        text-align: center;
    }
    .lft{
        border-right: 1px solid #fff;
        border-bottom: 1px solid #fff;
        border-left: 1px solid #F8A4AE;
        width: 58%;
        float: left;
        border-top-left-radius: 4px;
    }
    .rgt{
        border-right: 1px solid #F8A4AE;
        border-bottom: 1px solid #fff;
        width: 42%;
        float: right;
        border-top-right-radius: 4px;
    }
}
.table-body{
    width: 504px;
    margin: 0 auto;
    .lft, .rgt{
        font-size: 17px;
        font-family: Assistant-Bold, Assistant;
        font-weight: bold;
        color: #fff;
        line-height: 20px;
        box-sizing: border-box;
        padding:13px 0;
        background-color: #3A3835;
        height: 70px;
    }
    .lft{
        border-right: 1px solid #fff;
        border-bottom: 1px solid #fff;
        border-left: 1px solid #fff;
        width: 58%;
        float: left;
        text-align: center;
    }
    .pad-top-23{
        padding-top: 23px;
    }
    .rgt{
        border-right: 1px solid #fff;
        border-bottom: 1px solid #fff;
        width: 42%;
        float: right;
        text-align: right;
        padding: 23px 20px 0 0;
        .link{
            cursor: pointer;
            text-decoration: underline;
            color: #F8A4AE;
        }
    }
}
}
.bgd-pink2{
    width: 100%;
    padding-top: 127px;
    background: #F1DADD;
    height: 650px;
    box-sizing: border-box;
    margin-bottom: 18px;
    h1{
        word-break: break-word;
        text-align: center;
        margin-bottom: 20px;
        font-size: 52px;
        font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
        font-weight: 900;
        color: #3A3835;
        line-height: 61px;
    }
    ul{
        width: 600px;
        margin: 0 auto;
        li{
            margin-bottom: 22px;
            font-size: 18px;
            font-family: Assistant-Medium, Assistant;
            font-weight: 500;
            color: #3A3835;
            line-height: 24px;
            background-repeat: no-repeat;
            background-size: 24px auto;
            background-position: left center;
            background-image: url('../../assets/price/li.png');
            box-sizing: border-box;
            padding-left: 36px;
        }
    }
    h2{
        word-break: break-word;
        text-align: center;
        margin-bottom: 31px;
        font-size: 18px;
        font-family: Assistant;
        font-weight: 400;
        line-height: 22px;
        color: #3A3835;
    }
    h2{
        font-size: 22px;
        font-family: Lora-Regular, Lora;
        font-weight: 400;
        color: #3A3835;
        line-height: 28px;
    }
    .img{
        width: 156px;
        height: 24px;
        margin: 0 auto 0px auto;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        background-image: url('../../assets/price/4.png');
    }
}
.bgd-black{
    background: #3A3835;
    .card{
        width: 393px;
        height: 480px;
        background: #4E4C4A;
        border-radius: 8px;
        margin: 0 auto -120px auto;
        position: relative;
        top: -200px;
        box-sizing: border-box;
        padding: 102px 26px 0 26px;
        background-repeat: no-repeat;
        background-size: 60px 60px;
        background-position: 26px 30px;
        background-image: url('../../assets/price/1.png');
        h1{
            font-size: 22px;
            font-family: Lora-Regular;
            font-weight: normal;
            line-height: 28px;
            color: #FFFFFF;
            margin-bottom: 4px;
        }
        h2{
            font-size: 17px;
            font-family: Assistant-Medium;
            font-weight: 400;
            line-height: 22px;
            color: #FFFFFF;
            margin-bottom: 28px;
        }
        h3{
            font-size: 40px;
            font-family: Assistant-Bold;
            font-weight: bold;
            line-height: 52px;
            color: #FFFFFF;
            span{
                margin-right: 2px;
            }
        }
        h4{
            font-size: 17px;
            font-family: Assistant-Medium;
            font-weight: 400;
            line-height: 22px;
            color: #FFFFFF;
            box-sizing: border-box;
            margin-bottom: 12px;
            padding-left: 32px;
            background-repeat: no-repeat;
            background-size: 21px 21px;
            background-position: 0 center;
            background-image: url('../../assets/price/2.png');
        }
        button{
            width: 100%;
            border: none;
            height: 54px;
            background: #F8A4AE;
            opacity: 1;
            border-radius: 4px;
            font-size: 17px;
            font-family: Assistant-Bold;
            font-weight: bold;
            color: #3A3835;
            cursor: pointer;
        }
    }
    .triple{
        width: 1280px;
        margin: 0 auto;
        padding-bottom: 300px;
        .box{
            width: 380px;
            float: left;
            margin-right: 40px;
            h1{
                font-size: 40px;
                font-family: Assistant;
                font-weight: bold;
                line-height: 50px;
                color: #FFFFFF;
                word-break: break-word;
            }
            p{
                box-sizing: border-box;
                padding-left: 32px;
            }
            .tit{
                margin-bottom: 12px;
                font-size: 20px;
                font-family: Lora;
                font-weight: normal;
                line-height: 25px;
                color: #FFFFFF;
                background-repeat: no-repeat;
                background-size: 21px 21px;
                background-position: 0 center;
                background-image: url('../../assets/price/2.png');
                word-break: break-word;
            }
            .txt{
                margin-bottom: 50px;
                font-size: 17px;
                font-family: Assistant;
                font-weight: 400;
                line-height: 26px;
                color: #FFFFFF;
                opacity: 0.8;
            }
        }
        .box:nth-child(3){
            margin-right: 0;
        }
    }
}
.svgLine_box{
    width: 100%;
    overflow: hidden;
    margin-bottom: -51px;
}
.svgLine_box-carouselCard{
    width: 100%;
    overflow: hidden;
    margin-top: -250px;
}
.dark-wrap{
    background: #302E2C;
    padding: 50px 0 140px;
}
.dark-black{
    width: 1080px;
    margin: 0 auto;
    h1{
        font-size: 40px;
        font-family: Assistant;
        font-weight: bold;
        line-height: 56px;
        color: #FFFFFF;
        margin-bottom: 98px;
        text-align: center;
    }
    .box{
        width: 450px;
        float: left;
        margin-bottom: 90px;
        h2{
            font-size: 22px;
            font-family: Lora;
            font-weight: normal;
            line-height: 33px;
            color: #FFFFFF;
            word-break: break-word;
            margin-bottom: 12px;
        }
        p{
            font-size: 17px;
            font-family: Inter;
            font-weight: 400;
            line-height: 25px;
            color: #FFFFFF;
            opacity: 0.8;
            word-break: break-word;
        }
    }
    .box:nth-child(2n){
        float: right;
    }
    h3{
        font-size: 16px;
        font-family: Inter;
        font-weight: 400;
        line-height: 25px;
        color: #FFFFFF;
        opacity: 0.8;
        text-align: center;
        a{
            color: #FFFFFF;
            opacity: 0.8;
            cursor: pointer;
        }
    }
}
.pink-wrap2{
    width: 100%;
    box-sizing: border-box;
    padding: 0 40px;
    position: relative;
    top: -70px;
    .pink{
        width: 100%;
        height: 460px;
        background: #F1DADD;
        box-sizing: border-box;
        .content{
            width: 1220px;
            margin: 0 auto;
            .lft{
                width: 700px;
                padding-top: 60px;
                float: left;
                h1{
                    margin-bottom: 20px;
                    font-size: 52px;
                    font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
                    font-weight: 900;
                    color: #3A3835;
                    line-height: 60px;
                }
                h2{
                    margin-bottom: 40px;
                    font-size: 18px;
                    font-family: Assistant-Medium, Assistant;
                    font-weight: 500;
                    color: #3A3835;
                    line-height: 21px;
                    word-break: break-word;
                }
                button{
                    cursor: pointer;
                    border: none;
                    width: 222px;
                    height: 54px;
                    background: #F8A4AE;
                    opacity: 1;
                    border-radius: 4px;
                    font-size: 17px;
                    font-family: Assistant-Bold;
                    font-weight: bold;
                    color: #3A3835;
                }
            }
            .rgt{
                width: 505px;
                height: 420px;
                float: right;
                position: relative;
                top: -60px;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
                background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/b1ed0cf26fca4a2687ebdceede3248d6.png');
                border-radius: 4px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pricing/pricing.vue